const polygon = (sides, rotate = -90) => {
  const pts = [];
  for (let i = 0; i < sides; i++) {
    const a = ((360 / sides) * i + rotate) * (Math.PI / 180);
    pts.push(`${(50 + 50 * Math.cos(a)).toFixed(2)} ${(50 + 50 * Math.sin(a)).toFixed(2)}`);
  }
  return `M${pts.join(' L')} Z`;
};

const star = (points, inner = 0.45) => {
  const pts = [];
  for (let i = 0; i < points * 2; i++) {
    const r = i % 2 === 0 ? 50 : 50 * inner;
    const a = ((180 / points) * i - 90) * (Math.PI / 180);
    pts.push(`${(50 + r * Math.cos(a)).toFixed(2)} ${(50 + r * Math.sin(a)).toFixed(2)}`);
  }
  return `M${pts.join(' L')} Z`;
};

export const SHAPES = {
  triangle: { label: 'Triangle', path: 'M50 0 L100 100 L0 100 Z' },
  'right-triangle': { label: 'Right triangle', path: 'M0 0 L100 100 L0 100 Z' },
  diamond: { label: 'Diamond', path: 'M50 0 L100 50 L50 100 L0 50 Z' },
  pentagon: { label: 'Pentagon', path: polygon(5) },
  hexagon: { label: 'Hexagon', path: polygon(6, 0) },
  octagon: { label: 'Octagon', path: polygon(8, 22.5) },
  star: { label: 'Star', path: star(5) },
  'star-6': { label: '6-point star', path: star(6, 0.6) },
  burst: { label: 'Burst', path: star(12, 0.75) },
  heart: { label: 'Heart', path: 'M50 92 C20 70 0 52 0 30 C0 14 12 4 26 4 C36 4 45 10 50 18 C55 10 64 4 74 4 C88 4 100 14 100 30 C100 52 80 70 50 92 Z' },
  'arrow-right': { label: 'Arrow', path: 'M0 32 H60 V10 L100 50 L60 90 V68 H0 Z' },
  chevron: { label: 'Chevron', path: 'M0 0 H70 L100 50 L70 100 H0 L30 50 Z' },
  parallelogram: { label: 'Parallelogram', path: 'M25 0 H100 L75 100 H0 Z' },
  trapezoid: { label: 'Trapezoid', path: 'M20 0 H80 L100 100 H0 Z' },
  plus: { label: 'Plus', path: 'M35 0 H65 V35 H100 V65 H65 V100 H35 V65 H0 V35 H35 Z' },
  semicircle: { label: 'Semicircle', path: 'M0 100 A50 50 0 0 1 100 100 Z' },
  'quarter-circle': { label: 'Quarter circle', path: 'M0 100 V0 A100 100 0 0 1 100 100 Z' },
  ring: { label: 'Ring', path: 'M50 0 A50 50 0 1 0 50 100 A50 50 0 1 0 50 0 Z M50 22 A28 28 0 1 1 50 78 A28 28 0 1 1 50 22 Z', evenOdd: true },
  pill: { label: 'Pill', path: 'M25 10 H75 A40 40 0 0 1 75 90 H25 A40 40 0 0 1 25 10 Z' },
  'speech-bubble': { label: 'Speech bubble', path: 'M10 0 H90 Q100 0 100 10 V60 Q100 70 90 70 H40 L20 90 V70 H10 Q0 70 0 60 V10 Q0 0 10 0 Z' },
  banner: { label: 'Banner', path: 'M0 0 H100 L88 50 L100 100 H0 L12 50 Z' },
  badge: { label: 'Badge', path: 'M50 0 L60 8 L73 6 L78 18 L91 22 L90 35 L100 45 L92 56 L95 69 L83 75 L80 88 L67 88 L58 100 L50 92 L42 100 L33 88 L20 88 L17 75 L5 69 L8 56 L0 45 L10 35 L9 22 L22 18 L27 6 L40 8 Z' },
};

export const SHAPE_KEYS = Object.keys(SHAPES);

export const LINE_STYLES = [
  { key: 'solid', label: 'Solid' },
  { key: 'dashed', label: 'Dashed' },
  { key: 'dotted', label: 'Dotted' },
];

export const lineDash = (style, sw) => (style === 'dashed' ? [sw * 3, sw * 2] : style === 'dotted' ? [0.01, sw * 2] : []);
